
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visiting-faculty-panel-members",
      function () {
        return require("private-next-pages/visiting-faculty-panel-members/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visiting-faculty-panel-members"])
      });
    }
  